module.exports = __webpack_public_path__ + "static/media/my_club.3fb7223c.svg";